import Vue from 'vue';
import SearchInput from '../../core/components/SearchInput';

Vue.component('SearchInput', SearchInput);